(function () {
    'use strict';

    angular
        .module('app.warehouses')
        .controller('WarehousesAddController', AddController);

    AddController.$inject = ['$location', 'WarehousesService'];

    function AddController($location, Service) {

        /* jshint validthis:true */
        var vm = this;

        vm.title = '';

        vm.entity = {};

        vm.fields = Service.getFields();

        vm.create = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                Service.add(vm.entity).then(function (data) {
                    vm.loading = false;
                    $location.path('/warehouses/edit/' + data.Id);
                });
            }
        };
    }
})();